$( ->
  if $('#javascript_warning').length > 0
    $('#javascript_warning').remove()
    $('#javascript_dependent').show()
)
